import { AbstractControl, ValidationErrors, NG_ASYNC_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import { Task } from '../../../helpers/task';
import { BaseAsyncValidator } from '../../../modules/tcm-core.module';
import { SerializedItemDataService } from '../../../services/serialized-item-data.service';

@Directive({
    selector: '[serializedItemProductStyleSerialExistsAsyncValidator]',
    providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: SerializedItemProductStyleSerialExistsAsyncValidator, multi: true }],
    standalone: false
})
export class SerializedItemProductStyleSerialExistsAsyncValidator extends BaseAsyncValidator {

  private data;

  @Input()
  public get serializedItemProductStyleSerialExistsAsyncValidator(): { productStyleId: number, serial: string, id: number, isOrderCancelled: boolean } {
    return this.data;
  }

  public set serializedItemProductStyleSerialExistsAsyncValidator(value: { productStyleId: number, serial: string, id: number, isOrderCancelled: boolean }) {
    this.data = value;
    if (this._onChange) this._onChange();
  }

  constructor(private serializedDataService: SerializedItemDataService) {
    super('serializedItemProductStyleSerialExists');
  }

  protected async getValidationResultAsync(control: AbstractControl, cancellationToken: Promise<any>): Promise<ValidationErrors> {
    if (!control.value || !control.dirty || (!this.data.productStyleId && !this.data.serial))
      return null;

    const productStyleId = this.data.productStyleId ? this.data.productStyleId : control.value;
    const serial = this.data.serial ? this.data.serial : control.value;

    await Task.delay(200, cancellationToken);
    const isExists = await this.serializedDataService.checkProductStyleSerialExistsAsync(productStyleId, serial, this.data.id, this.data.isOrderCancelled, cancellationToken);

    if (isExists) {
      return this.buildValidationErrorResult({});
    } else {
      return null;
    }
  }
}
